export default __webpack_public_path__ + "static/media/my-profile.0e35adbf.svg";